import * as React from 'react';

function SvgHeart(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 21.46c-.309 0-.61-.093-.865-.267-3.779-2.565-5.414-4.324-6.317-5.423-1.923-2.344-2.843-4.75-2.817-7.355C2.03 5.429 4.426 3 7.34 3c2.119 0 3.587 1.194 4.441 2.188a.29.29 0 00.436 0C13.072 4.193 14.54 3 16.659 3c2.915 0 5.31 2.429 5.34 5.415.026 2.606-.895 5.012-2.817 7.356-.902 1.099-2.538 2.857-6.317 5.422a1.539 1.539 0 01-.865.268z" })));
}

export default SvgHeart;
